export default class InstructorCalendar {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    customerID: 'validString',
    userID: 'validString',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async createAvailabilityEvent(instructorID, availabilityEventObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/instructor/' + instructorID + '/availabilityEvent/' + availabilityEventObj.startTime;
    req.body = availabilityEventObj;
    return await req.exec();
  }
  async updateAvailabilityEvent(instructorID, availabilityEventObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/instructor/' + instructorID + '/availabilityEvent/' + availabilityEventObj.startTime;
    req.body = availabilityEventObj;
    return await req.exec();
  }
  async deleteAvailabilityEvent(instructorID, startTime) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/instructor/' + instructorID + '/availabilityEvent/' + startTime;
    return await req.exec();
  }
  async getAvailabilityEvent(instructorID, startTime) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/instructor/' + instructorID + '/availabilityEvent/' + startTime;
    return await req.exec();
  }
  async getEvents(instructorID, listObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/instructor/' + instructorID + '/events/';
    req.body = listObj;
    return await req.exec();
  }
}
